import React from 'react';
import styled from '@emotion/styled';
import { AssetComponent } from '../../../../redux/slices/slice_types';
import { Typography, darken } from '@mui/material';
import AssetComponentBox from './AssetComponentBox';

interface AssetListGroupedProps {
  assets: AssetComponent[];
}

const AssetListGrouped = ({ assets }: AssetListGroupedProps) => {
  // group assets by version id
  const groupedAssets = assets.reduce((acc, asset) => {
    if (!asset.version_external_id) return acc;
    if (!acc[asset.version_external_id]) {
      acc[asset.version_external_id] = [];
    }
    acc[asset.version_external_id].push(asset);
    return acc;
  }, {} as { [key: string]: AssetComponent[] });

  return (
    <div>
      {Object.keys(groupedAssets).map((externalId) => {
        const versionName = groupedAssets[externalId][0].version_name || 'Unknown';
        return (
          <StyledFieldset key={externalId}>
            <legend>
              <Version>
                <strong>{versionName}</strong>{' '}
                <Typography variant="caption" sx={{ borderLeft: `1px solid white`, pl: 1, ml: 1 }}>
                  {externalId}
                </Typography>
              </Version>
            </legend>
            {groupedAssets[externalId].map((asset) => (
              <AssetComponentBox key={asset.filename} asset={asset} />
            ))}
          </StyledFieldset>
        );
      })}
    </div>
  );
};

export default AssetListGrouped;

const StyledFieldset = styled.fieldset`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  border-width: 2px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: 100%;
  border-color: ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => theme.spacing(2, 2, 1)};
`;

const Version = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  text-decoration: none;
  font-size: 1rem;
  transition: opacity 0.2s ease;
  color: ${({ theme }) => darken(theme.palette.text.primary, 0.2)};
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 0 8px;
  border-radius: 3px;
  margin-top: 3px;
  display: inline-flex;
  line-height: 1.2;
  height: 1.2rem;

  .MuiTypography-caption {
    line-height: 1.33;
  }

  &:hover {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  &:active {
    opacity: 0.6;
  }
`;
